export default __webpack_public_path__ + "static/media/d10.5dce4f2f.png";